"use client";

import NewListingComponent from "@/components/NewListing/new-listing";
import { newListingSubRoutes } from "@/lib/localizedRoutes/localizedRoutes";
import { makeLocalizedHrefNoLocale } from "@/lib/localizedRoutes/routeHelpers";
import { useLocale } from "next-intl";

export default function ClientNewListingPage() {
  const locale = useLocale();
  const subRoute = newListingSubRoutes.publish[locale];

  // 🚀 The generator function!
  const handleRedirect = (listingId: string | number) => {
    return makeLocalizedHrefNoLocale(locale, "new-listing", [
      subRoute,
      `${listingId}`,
    ]);
  };
  return <NewListingComponent getRedirectPath={handleRedirect} />;
}
